import Vue from 'vue'
import Vuex from 'vuex'
import brands from './modules/brands';
import types from './modules/types';
import methods from './modules/methods';
import build from './modules/build';
import order from './modules/order';
import categories from './modules/categories';
import products from './modules/products';
import images from './modules/images';
import settings from './modules/settings';
import environment from './modules/environment';
import ABTesting from './modules/ab-testing';
import infoPopup from './modules/info-popup';
import { i18n } from '@/main'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    brands,
    types,
    methods,
    build,
    order,
    categories,
    products,
    images,
    settings,
    environment,
    ABTesting,
    infoPopup,
  },

  state: {
    searchResult: {},
    selectedCar: [],
    orderModal: false,
    productModal: false,
    device: null,
    discounts: {},
    buildId: null,
    environmentId: null,
  },
  mutations: {
    searchResult(state, data) {
      state.searchResult = data;
    },
    selection(state, data) {
      state.selectedCar = data;
    },
    setOrderModal(state, data) {
      state.orderModal = data;
    },
    setProductModal(state, data) {
      state.productModal = data;
    },
    setDevice(state, data) {
      state.device = data;
    },
    init(state) {
      const dataSet = document.getElementById('app').dataset;

      if (dataSet.discounts) {
        state.discounts = JSON.parse(dataSet.discounts);
      }

      const buildNrQueryParam = new URLSearchParams(window.location.search).get('build');
      state.buildId = buildNrQueryParam || dataSet.build || dataSet.buildId || null;

      const environmentQueryParam = new URLSearchParams(window.location.search).get('environment');
      state.environmentId = environmentQueryParam || dataSet.environmentId || process.env.VUE_APP_ENVIRONMENT_ID || 3;
    }
  },
  actions: {
    async initialize({ dispatch, getters }) {
      return Promise.all([
        dispatch('brands/fetch'),
        dispatch('types/fetch'),
        dispatch('methods/fetch'),
        dispatch('categories/fetch'),
        dispatch('images/fetch'),
        dispatch('settings/fetch'),
        dispatch('environment/fetch'),
        dispatch('infoPopup/fetch'),
      ]).then((val) => {
        i18n.locale = getters['environment/locale'];

        return 'success';
      })
    },
    setSelection({ commit }, data) {
      commit('selection', data);
      commit('build/SET_CAR_MODEL', data.carModel);
      commit('build/SET_BRAND', data.carBrand);
    },
    setProductPopup({ commit }, value) {
      commit('setProductModal', value)
    },
    setDevice({ commit }, device) {
      commit('setDevice', device);
    }
  },
  getters: {
    getSearchResult(state) {
      return state.searchResult;
    },
    getSelectedCar(state) {
      return state.selectedCar;
    },
    getOrderModal(state) {
      return state.orderModal;
    },
    getProductModal(state) {
      return state.productModal;
    },
    getDevice(state) {
      return state.device;
    },
  },
})
